var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVolume = function SvgVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.324 8.538H3.25c-.692 0-1.25.565-1.25 1.23v4.463c0 .666.558 1.231 1.25 1.231h3.074L12 19.156V4.844L6.324 8.538zm-.297-1H3.25C2.014 7.538 1 8.543 1 9.768v4.463c0 1.226 1.014 2.231 2.25 2.231h2.777L13 21V3L6.027 7.538z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12a7 7 0 01-7 7v1a8 8 0 100-16v1a7 7 0 017 7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14a2 2 0 100-4v1a1 1 0 110 2v1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 17a5 5 0 000-10v1a4 4 0 010 8v1z"
  })));
};
export default SvgVolume;